import { columnCardCarousel } from '@mage-ui/styled-system/recipes';
import { ColumnCardBase } from './ColumnCardBase';

export const ColumnCardCarousel = ({ data, ...props }) => {
	return (
		<ColumnCardBase
			className={{
				root: columnCardCarousel().root,
				cta: columnCardCarousel().cta,
			}}
			title={data.title}
			altImg={data.alt_img}
			src={data.img_round_carousel}
			ctaText={data.cta_text}
			ctaSlug={data.cta_slug}
			{...props}
		/>
	);
};
